module.exports = __webpack_public_path__ + "ins08.png?5bed735fadb67fcd191c735a29056e8a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ins08.png
// module id = 159
// module chunks = 0